import type { AuthenticatedUser, LoginResponse } from '@vce/shared';

const STORAGE_KEY = 'vce.session';

export interface Session {
  accessToken: string;
  refreshToken: string;
  user: AuthenticatedUser;
}

export function loadSession(): Session | null {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Session;
  } catch {
    window.localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function saveSession(session: LoginResponse): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  window.dispatchEvent(new Event('vce:session'));
}

export function clearSession(): void {
  window.localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event('vce:session'));
}
